import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../services/api';

/** FIX-D337 (D-337 §2) - the counter on "מסמכים לחתימה": documents waiting for the OTE manager. */
export default function DocumentsToSignBadge({ rail }: { rail: boolean }) {
  const { t } = useTranslation();
  const q = useQuery({
    queryKey: ['document-review-count'],
    queryFn: async () => (await api.getDocumentReviewCount()).data?.count ?? 0,
    refetchInterval: 120_000,
    staleTime: 60_000,
  });
  const n = q.data ?? 0;
  if (!n) return null;
  return (
    <span
      className={`${rail ? 'absolute -top-1 -end-1' : 'ms-auto'} inline-flex min-w-5 items-center justify-center rounded-full bg-warning-100 px-1.5 text-xs font-semibold text-warning-800`}
      aria-label={t('docReview.badge', { count: n })}
    >
      {n}
    </span>
  );
}
